import { Content } from './styles'
import {
  faDollarSign,
  faHouse,
  faKey,
  faList,
  faMoneyBillTransfer,
  faPaperclip,
  faUserGroup,
} from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'

import { useUser } from 'main/hooks/useUser'

import { PageHeader } from 'presentation/components/organisms/pageHeader'
import { PageFooter } from 'presentation/components/organisms/pageFooter'

const NavigationV2 = ({ hideMenu, children }) => {
  const { user } = useUser()

  const destinations = [
    {
      pathname: '/',
      icon: faHouse,
      displayName: 'Início',
    },
    {
      pathname: '/departamentos',
      icon: faList,
      displayName: 'Departamentos',
    },
    {
      pathname: '/colaboradores',
      icon: faUserGroup,
      displayName: 'Colaboradores',
    },
    {
      pathname: '/cartoes',
      icon: faCreditCard,
      displayName: 'Cartões',
    },
    {
      pathname: '/recargas',
      icon: faMoneyBillTransfer, //faMoneyBill1,
      displayName: 'Recargas',
    },
    {
      pathname: '/financeiro',
      icon: faDollarSign,
      displayName: 'Financeiro',
    },
    {
      pathname: '/relatorios',
      icon: faPaperclip,
      displayName: 'Relatórios',
    },
  ]
  const userDestinations = [
    {
      pathname: '/usuarios',
      icon: faKey,
      displayName: 'Acessos e permissões',
    },
  ]

  return (
    <>
      {hideMenu ? (
        children
      ) : (
        <>
          <PageHeader
            navigationDestinations={destinations}
            userMenuDestinations={user?.level === 'admin' ? userDestinations : []}
          />
          <Content>{children}</Content>
          <PageFooter />
        </>
      )}
    </>
  )
}

export default NavigationV2
